(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.querySelector(".mobile-menu-toggle");
  const headerContainer = document.querySelector(".banner-header");

  if (toggleBtn && headerContainer) {
    const hamburgerIcon = toggleBtn.querySelector(".icon-hamburger");
    const closeIcon = toggleBtn.querySelector(".icon-close");

    toggleBtn.addEventListener("click", () => {
      const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", !isExpanded);
      headerContainer.classList.toggle("drawer-open");

      if (isExpanded) {
        hamburgerIcon.style.display = "block";
        closeIcon.style.display = "none";
      } else {
        hamburgerIcon.style.display = "none";
        closeIcon.style.display = "block";
      }
    });
  }

  const animatedButtons = document.querySelectorAll(".animated-btn");
  animatedButtons.forEach(button => {
    const arrow = button.querySelector(".arrow-icon");
    button.addEventListener("mouseenter", () => {
      if (arrow) arrow.style.transform = "translateX(5px)";
    });
    button.addEventListener("mouseleave", () => {
      if (arrow) arrow.style.transform = "translateX(0)";
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
